import { Controller } from "@hotwired/stimulus"

export default class ShowController extends Controller {
  declare titleDisplayTarget: HTMLElement
  declare titleFormTarget: HTMLFormElement
  declare titleInputTarget: HTMLInputElement

  static targets = [
    "titleDisplay",
    "titleForm",
    "titleInput"
  ]

  async enableTitleEdit(event: Event) {
    event.preventDefault()

    const currentTitle = this.titleDisplayTarget.textContent?.trim() || ""

    this.titleInputTarget.value = currentTitle

    this.titleDisplayTarget.classList.add("d-none")
    this.titleFormTarget.classList.remove("d-none")

    this.titleInputTarget.focus()
    this.titleInputTarget.select()
  }

  saveTitleEdit() {
    this.titleFormTarget.requestSubmit()
  }

  handleTitleKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.saveTitleEdit()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancelTitleEdit()
    }
  }

  private cancelTitleEdit() {
    this.titleFormTarget.classList.add("d-none")
    this.titleDisplayTarget.classList.remove("d-none")
  }
}
